/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m10.7562 14.3045 4.7741-4.7742a.75.75 0 0 0-1.0606-1.0606L9.7424 13.197.7043 9.8078c-.949-.356-.9359-1.7029.0199-2.0402L22.5507.0642c.8726-.308 1.7058.547 1.3753 1.4113L15.5902 23.277c-.3678.9619-1.743.919-2.0502-.0639l-2.7838-8.9085Z"
    clipRule="evenodd"
  />,
  'SendFilled'
);
